export default __webpack_public_path__ + "static/media/logo.08257ed6.svg";